import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';
const KEY = 'vs_vid';

function getVisitorId() {
  const m = document.cookie.match(new RegExp(`(?:^|; )${KEY}=([^;]*)`));
  if (m) return decodeURIComponent(m[1]);
  const vid = Math.random().toString(36).slice(2) + Date.now().toString(36);
  document.cookie = `${KEY}=${vid}; max-age=31536000; path=/; SameSite=Lax`;
  return vid;
}

const seen = new Set();

export function trackVisit(extra = {}) {
  try {
    const key = window.location.pathname + (extra.job_slug || '');
    if (seen.has(key)) return;
    seen.add(key);
    const params = new URLSearchParams(window.location.search);
    axios.post(`${API_URL}/api/track/visit`, {
      visitor_id: getVisitorId(),
      path: window.location.pathname,
      referrer: document.referrer || '',
      src: params.get('src') || params.get('utm_source') || '',
      ...extra,
    }, { withCredentials: true }).catch(() => {});
  } catch { /* tracking must never break the page */ }
}
